module.exports = __webpack_public_path__ + "img/home-07-cosmo-01-popup-02.98dee7f9.jpg";